export const AgentTemplateIconsMap: Record<string, string> = {
  'Sales Demo': '\u{1F4CA}',
  'Customer Onboarding': '\u{1F680}',
  'Sales Intro': '\u{1F5E3}'
};
